<template>
	<div class="layer-project" data-project-name="db-life">
		<!-- Project Name -->
		<div class="layer-project-detail">
			<section class="project-visual">
				<div>
					<h1 class="project-tit">DB Life <br />Mobile Site</h1>
					<a href="http://m.idblife.com" class="link" target="_blank"
						>m.idblife.com</a
					>
				</div>
			</section>
			<!-- Details [s] -->
			<section class="project-overview">
				<div class="inner-section">
					<h2 class="project-overview-tit">Overview</h2>
					<p class="project-overview-txt">
						직관적이고 심플한 정보설계로 사용성을 개선한 모바일 웹 서비스를
						구축하였습니다.
					</p>
					<div class="project-overview-diagram">
						<div class="diagram01">
							<ul>
								<li class="item01">Simple</li>
								<li class="item02">Imporved<br />UI/UX Design</li>
								<li class="item03">User<br />Convenience</li>
							</ul>
						</div>
						<p class="diagram02">DB생명<br />MOBILE SITE</p>
					</div>
				</div>
			</section>
			<!-- Details [e] -->
			<!-- section01 : mobile-web [s] -->
			<section class="section full section01">
				<div class="inner-section">
					<div class="information-area">
						<strong class="project-subtit">Mobile</strong>
						<p class="sub-text">
							직관적이고 심플한 정보설계로 복잡한 보험상품 정보와 계약관리 현황
							등을 쉽게 파악할 수 있도록 구성하였습니다. 또한 모바일 웹으로 언제
							어디서나 쉽고 편리하게 이용 할 수 있는 보험 서비스를
							제공합니다.<br />
							사용빈도가 높은 핵심 기능을 메인에 노출하여 고객의 맞춤 서비스를
							제공합니다.
						</p>
					</div>
					<div class="img-box">
						<img
							src=""
							alt=""
							data-src="/static/img/project-detail/db-life/mobile-web-01-img@m.png"
						/>
					</div>
				</div>
			</section>
			<!-- section01 : mobile-web [e] -->
			<!-- section02 : layout [s] -->
			<section class="section full section02">
				<div class="inner-section">
					<div class="information-area">
						<strong class="project-subtit">Layout</strong>
					</div>
					<div class="layout-swiper-area">
						<div class="layout-swiper">
							<ul class="swiper-wrapper">
								<li class="swiper-slide">
									<img
										src=""
										alt=""
										data-src="/static/img/project-detail/db-life/layout-img-main@m.png"
									/>
								</li>
								<li class="swiper-slide">
									<img
										src=""
										alt=""
										data-src="/static/img/project-detail/db-life/layout-img-sub@m.png"
									/>
								</li>
							</ul>
							<!-- Add Pagination -->
							<div class="swiper-pagination" data-bgcolor="white"></div>
						</div>
					</div>
				</div>
			</section>
			<!-- section02 : layout [e] -->
			<!-- section03 : device [s] -->
			<section class="section section03 full">
				<img
					src=""
					alt=""
					data-src="/static/img/project-detail/db-life/img-section03@m.png"
				/>
			</section>
			<!-- section03 : device [e] -->
			<!-- section04 : device02 [s] -->
			<section class="section section04">
				<div class="inner-section">
					<div class="device-swiper-area">
						<div class="device02-swiper">
							<ul class="swiper-wrapper">
								<li class="swiper-slide">
									<img
										src=""
										alt=""
										data-src="/static/img/project-detail/db-life/device-mockup02-01@m.png"
									/>
								</li>
								<li class="swiper-slide">
									<img
										src=""
										alt=""
										data-src="/static/img/project-detail/db-life/device-mockup02-02@m.png"
									/>
								</li>
								<li class="swiper-slide">
									<img
										src=""
										alt=""
										data-src="/static/img/project-detail/db-life/device-mockup02-03@m.png"
									/>
								</li>
							</ul>
							<!-- Add Pagination -->
							<div class="swiper-pagination"></div>
						</div>
					</div>
				</div>
			</section>
			<!-- section04 : device02 [e] -->
			<!-- section05 : mobile [s] -->
			<section class="section full section05">
				<img
					src=""
					alt=""
					data-src="/static/img/project-detail/db-life/mobile-01-img@m.png"
				/>
			</section>
			<!-- section05 : mobile [e] -->
			<!-- section06 : project identity [s]-->
			<section class="section section06">
				<div class="inner-section">
					<div class="point-area">
						<div class="font-area-wrap">
							<div class="img">
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/db-life/font-lg-smart.png"
								/>
							</div>
						</div>
						<div class="point-color-area">
							<div>
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/db-life/point-color.png"
								/>
							</div>
						</div>
					</div>
					<div class="point-icon-area">
						<div>
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/db-life/icon-list@m.png"
							/>
						</div>
					</div>
				</div>
			</section>
			<!-- section06 : project identity [e]-->
			<section class="project-client">
				<strong class="a11y-hidden">DB생명</strong>
			</section>
		</div>

		<app-pjmove></app-pjmove>
	</div>
</template>

<script>
import Swiper from "../../static/js/swiper.min.js"; /* if use swiper.min.js */
import pjMove from "../components/pjMove.vue";
import projectCommon from "../assets/js/projectCommon.js";

export default {
	components: {
		"app-pjmove": pjMove,
	},
	mixins: [projectCommon],
	mounted: function () {
		this.projectInit();

		var isPcWebMain = false;
		var pcWebMainSwiper;
		var isMobileWebSub = false;
		var mobileWebSubSwiper;

		pcWebMainSet();
		mobileWebSubSet();

		$(window).on("resize", function () {
			resizeSet();
		});

		function resizeSet() {
			var w = $(window).outerWidth();
			if (w >= 712 && isPcWebMain) {
				pcWebMainSwiper.destroy();
				isPcWebMain = false;
			} else {
				pcWebMainSet();
			}

			if (w >= 712 && isMobileWebSub) {
				mobileWebSubSwiper.destroy();
				isMobileWebSub = false;
			} else {
				mobileWebSubSet();
			}
		}

		function pcWebMainSet() {
			var w = $(window).outerWidth();

			if (isPcWebMain | (w >= 712)) {
				return;
			}
			isPcWebMain = true;
			pcWebMainSwiper = new Swiper(".layout-swiper", {
				slidesPerView: "auto",
				spaceBetween: 12,
				centeredSlides: true,
				pagination: {
					el: ".layout-swiper .swiper-pagination",
					clickable: true,
				},
			});
		}

		function mobileWebSubSet() {
			var w = $(window).outerWidth();

			if (isMobileWebSub | (w >= 712)) {
				return;
			}
			isMobileWebSub = true;
			mobileWebSubSwiper = new Swiper(".device02-swiper", {
				slidesPerView: "auto",
				spaceBetween: 15,
				centeredSlides: true,
				pagination: {
					el: ".device02-swiper .swiper-pagination",
					clickable: true,
				},
			});
		}
	},
};
</script>
<!-- css 추가 -->
<style scoped>
@import "../../static/css/projects.css"; /* Common Project Detail Page */
/* Common */
.sub-text {
	word-break: keep-all;
}
.project-subtit {
	display: block;
	margin-bottom: 10px;
	font-size: 3.3rem;
}
.sub-text {
	line-height: 1.5;
	font-weight: 500;
}
.information-area {
	padding: 0 15px;
}
.layer-project-detail {
	overflow: hidden;
}
@media screen and (min-width: 712px) {
	.project-subtit {
		font-size: 3.3rem;
	}
	.information-area {
		padding: 0 40px;
	}
}
@media screen and (min-width: 1280px) {
	.project-subtit {
		font-size: 56px;
	}
	.sub-text {
		font-size: 15px;
		line-height: 28px;
		font-weight: 400;
	}
	.information-area {
		padding: 0;
	}
	.inner-section {
		max-width: 1280px;
		margin: 0 auto;
	}
}

/* Project Visual, Project CI */
.project-client {
	background: url(/static/img/project-detail/db-life/ci.png) 50% / auto 44.5px
		no-repeat;
}
@media screen and (max-width: 711px) {
	.project-visual {
		background-image: url(/static/img/project-detail/db-life/bg-overview@m.jpg);
	}
	.project-tit br {
		display: block;
	}
}
@media screen and (min-width: 712px) {
	.project-visual {
		background-image: url(/static/img/project-detail/db-life/bg-overview@t.jpg);
	}
	.project-tit br {
		display: none;
	}
	.project-client {
		background-size: auto 70px;
	}
}
@media screen and (min-width: 1280px) {
	.project-visual {
		background-image: url(/static/img/project-detail/db-life/bg-overview@w.jpg);
	}
	.project-tit br {
		display: none;
	}
	.project-client {
		background-size: auto 100px;
	}
}
/* Overview */
.project-overview-txt {
	margin-bottom: 30px;
	line-height: 1.5;
}
.project-overview {
	background-color: #6ecf5e;
	color: #fff;
}
.project-overview-diagram {
	line-height: 1.2;
	text-align: center;
}
.project-overview-diagram .diagram01 ul {
	display: flex;
	align-items: center;
	justify-content: center;
}
.project-overview-diagram .diagram01 ul li {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100px;
	height: 100px;
	border: 1px solid #fff;
	border-radius: 50%;
}
.project-overview-diagram .diagram01 li + li {
	margin-left: -6px;
}
.project-overview-diagram .diagram01 .item03 {
	padding: 8px;
}
.project-overview-diagram .diagram02 {
	position: relative;
	width: 140px;
	height: 140px;
	margin: 70px auto 0;
	padding-top: 54px;
	color: #00854a;
	background-color: #fff;
	border-radius: 50%;
	line-height: 17px;
}
.project-overview-diagram .diagram02:before {
	content: "";
	position: absolute;
	top: -55px;
	left: 50%;
	width: 1px;
	height: 40px;
	background-color: #fff;
}
@media screen and (min-width: 712px) {
	.project-overview-txt {
		margin-bottom: 20px;
	}
	.project-overview-diagram {
		display: flex;
		justify-content: space-between;
		max-width: 632px;
		margin: 0 auto;
		line-height: 17px;
		font-weight: 500;
	}
	.project-overview-diagram .diagram01 ul li {
		width: 132px;
		height: 132px;
	}
	.project-overview-diagram .diagram01 .item01 {
		padding: 25px;
	}
	.project-overview-diagram .diagram02 {
		width: 132px;
		height: 132px;
		margin: 0;
		padding-top: 50px;
	}
	.project-overview-diagram .diagram02:before {
		width: 87px;
		height: 1px;
		top: 50%;
		left: -97px;
	}
}
@media screen and (min-width: 1280px) {
	.project-overview {
		padding: 53px 0 80px;
	}
	.project-overview .inner-section {
		padding: 0;
	}
	.project-overview-tit {
		font-size: 36px;
		margin-bottom: 9px;
	}
	.project-overview-txt {
		margin-bottom: 55px;
		font-size: 15px;
		line-height: 28px;
	}
	.project-overview-diagram {
		max-width: 1280px;
		font-size: 20px;
		line-height: 26px;
		padding: 0 75px;
	}
	.project-overview-diagram .diagram01 ul li {
		width: 230px;
		height: 230px;
	}
	.project-overview-diagram .diagram01 .item01,
	.project-overview-diagram .diagram01 .item03 {
		padding: 60px;
	}
	.project-overview-diagram .diagram02 {
		width: 230px;
		height: 230px;
		padding-top: 80px;
		font-size: 23px;
		line-height: 30px;
	}
	.project-overview-diagram .diagram02:before {
		width: 162px;
		height: 2px;
		top: 50%;
		left: -195px;
	}
}
.section01 {
	background-color: #f7f7f7;
}
.section01 .img-box {
	text-align: center;
}
@media screen and (max-width: 711px) {
	.section01.full {
		padding: 30px 0 0;
	}
	.section01 .information-area br {
		display: none;
	}
}
@media screen and (min-width: 712px) {
	.layer-project-detail > section.section01 {
		padding-bottom: 0;
	}
	.section01.full {
		padding: 30px 0 0;
	}
	.section01 .information-area {
		padding: 0 40px;
		width: 100%;
	}
	.section01 .img {
		width: 100%;
		text-align: center;
	}
	.section01 .information-area br {
		display: none;
	}
}
@media screen and (min-width: 1280px) {
	.section01.full {
		padding: 150px 0 0;
	}
	.section01 .inner-section {
		position: relative;
		display: block;
		max-width: 1280px;
	}
	.section01 .inner-section:after {
		content: "";
		display: block;
		clear: both;
	}
	.section01 .information-area {
		position: absolute;
		top: -60px;
		left: 0;
		width: 700px;
		padding: 0;
	}
	.section01 .information-area .project-subtit {
		margin-bottom: 5px;
	}
	.section01 .information-area br {
		display: block;
	}
	.section01 .img-box {
		width: 1437px;
	}
}
.section02 {
	position: relative;
	background-color: #f7f7f7;
}
.section02 .inner-section {
	text-align: center;
}
.section02 .information-area {
	position: relative;
	z-index: 5;
	margin-bottom: 20px;
}
.section02 .project-subtit {
	margin-bottom: 0;
	text-align: center;
}
.section02 .swiper-container-horizontal > .swiper-pagination-bullets {
	bottom: 35px;
}
@media screen and (max-width: 711px) {
	.section02.full {
		padding: 0;
	}
	.section02 .layout-swiper-area::after {
		content: "";
		position: absolute;
		left: 0;
		bottom: 0;
		width: 100%;
		height: 113.28vw;
		background-color: #b3a184;
	}
}
@media screen and (min-width: 712px) {
	.section02 .layout-swiper-area {
		position: relative;
	}
	.section02 .layout-swiper-area::after {
		content: "";
		position: absolute;
		left: 0;
		bottom: -4.72vw;
		width: 100%;
		height: 40.37vw;
		background-color: #b3a184;
	}
	.section02 .swiper-wrapper li {
		width: 50%;
	}
	.section02 .swiper-pagination {
		display: none;
	}
}
@media screen and (min-width: 1280px) {
	.section02::after {
		content: "";
		position: absolute;
		left: 0;
		bottom: -120px;
		width: 100vw;
		height: 630px;
		background-color: #b3a184;
	}
	.section02 .layout-swiper-area::after {
		display: none;
	}
	.section02 .project-subtit {
		margin-bottom: 20px;
	}
	.section02 .img img {
		width: auto;
	}
}
.section03.full {
	position: relative;
	padding: 0;
}
@media screen and (max-width: 711px) {
	.section03 img {
		width: 100%;
	}
}
.section04 {
	position: relative;
	background: url(/static/img/project-detail/db-life/bg-device-mockup02@m.png) 0
		67% no-repeat;
	background-size: 100%;
	text-align: center;
	background-color: #f7f7f7;
}
.section04 .swiper-slide {
	text-align: center;
	margin-left: 4.68vw;
}
.section04 .device02-swiper .swiper-wrapper li {
	width: 100%;
	text-align: center;
}
.section04 .device02-swiper .swiper-wrapper li img {
	width: 66.87vw;
}
.section04 .swiper-pagination {
	bottom: -10px;
}
@media screen and (max-width: 711px) {
	.section04 {
		padding: 0;
	}
	.section04:after {
		content: "";
		position: absolute;
		left: 0;
		bottom: 0;
		width: 100%;
		height: 27.86vw;
		background-color: #fff;
	}
	.section04 .device02-swiper .swiper-wrapper li {
		margin-left: 4.68vw;
	}
}
@media screen and (min-width: 712px) {
	.section04 {
		background: url(/static/img/project-detail/db-life/bg-device-mockup02@t.png)
			no-repeat;
		background-size: 100%;
		background-position: 0 35vw;
		padding-top: 0;
		background-color: #f7f7f7;
	}
	.section04:after {
		content: "";
		position: absolute;
		left: 0;
		bottom: 0;
		width: 100%;
		height: 14.52vw;
		background-color: #fff;
	}
	.section04 .swiper-wrapper {
		display: flex;
		justify-content: center;
	}
	.section04 .swiper-wrapper li {
		width: 25vw;
	}
	.section04 .swiper-wrapper li:nth-child(2) {
		margin-top: 6vw;
	}
	.section04 .swiper-wrapper li:nth-child(3) {
		margin-top: 12.04vw;
	}
	.section04 .swiper-pagination {
		display: none;
	}
	.section04 .device02-swiper .swiper-wrapper li {
		width: 27.73vw;
	}
	.section04 .device02-swiper .swiper-wrapper li img {
		width: 27.73vw;
	}
}
@media screen and (min-width: 1280px) {
	.section04 {
		padding: 0;
		background: url(/static/img/project-detail/db-life/bg-device-mockup02@w.png)
			no-repeat;
		background-size: 100%;
		background-position: 0 70%;
		background-color: #f7f7f7;
	}
	.section04:before {
		content: "";
		position: absolute;
		left: 0;
		bottom: 8.59vw;
		width: 100%;
		height: 200px;
		background-color: #bdb3a2;
	}
	.section04:after {
		content: "";
		position: absolute;
		left: 0;
		bottom: 0;
		width: 100%;
		height: 160px;
		background-color: #fff;
	}
	.swiper-wrapper {
		display: flex;
		justify-content: center;
		text-align: center;
	}
	.section04 .device02-swiper .swiper-wrapper li {
		width: 433px;
		margin: 0;
	}
	.section04 .device02-swiper .swiper-wrapper li + li {
		margin-left: 20px;
	}
	.section04 .device02-swiper .swiper-wrapper li img {
		width: 433px;
	}
	.section04 .swiper-wrapper li:nth-child(2) {
		margin-top: 100px;
	}
	.section04 .swiper-wrapper li:nth-child(3) {
		margin-top: 200px;
	}
}
.section05 {
	overflow-y: auto;
}
.section05 img {
	width: auto;
	max-width: none;
}
@media screen and (min-width: 712px) {
	.section05 img {
		width: 100%;
	}
}
@media screen and (min-width: 1280px) {
	.section05 {
		padding: 118px 20px 110px;
	}
}
.section06 {
	background-color: #4e4e4e;
	text-align: center;
}
.point-icon-area {
	padding-top: 30px;
}
.point-icon-area div + div {
	padding: 15px 20px 0 20px;
}
@media screen and (max-width: 711px) {
	.font-area-wrap {
		text-align: left;
	}
	.point-color-area {
		padding-top: 30px;
	}
}
@media screen and (min-width: 712px) {
	.point-area {
		display: flex;
		justify-content: space-between;
	}
	.section06 .inner-section {
		padding-top: 50px;
		padding-bottom: 20px;
	}
	.point-icon-area {
		padding: 0 90px;
		margin-top: 45px;
	}
	.point-area .point-color-area {
		width: 35.81vw;
	}
	.font-area-wrap {
		width: 37.5vw;
	}
	.color-area-wrap .color li {
		width: 55px;
		text-align: center;
	}
}
@media screen and (min-width: 1280px) {
	.section06 .inner-section {
		padding: 118px 0 110px;
	}
}
</style>


// WEBPACK FOOTER //
// src/projects/db-life.vue